/**
 * Formats a currency amount expressed in minor units (e.g. cents) for display
 * in the given locale, e.g. formatMinorUnitsAmount(49000, 'usd', 'en') => "$490.00".
 */
export function formatMinorUnitsAmount(amount: number, currency: string, locale: string): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency || 'USD',
  }).format(amount / 100);
}
